import React from 'react';
import { connect } from 'react-redux';
import { pageWrapper, EEventNames } from '../../../../../client/analytics';
import Container from '../../../../common/components/container';
import OnboardingStatistics from '../../../learning/containers/onboarding/statistics';
import * as networkSelector from '../../../network/selectors/network';

import '../../../learning/components/statistics/styles.scss';

const OnboardingStatisticsContainer = ({ match, history, network }) => (
  <Container name="Onboarding">
    <Container.Content>
      <OnboardingStatistics network={match.params.networkId && network} history={history} />
    </Container.Content>
  </Container>
);

const mapStateToProps = (state) => ({
  network: networkSelector.selected(state),
});

export default connect(mapStateToProps)(pageWrapper(EEventNames.VISITED_ONBOARDING_ANALYTICS_PAGE)(OnboardingStatisticsContainer));
